import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MovingIcon from "@mui/icons-material/Moving";
import GradeIcon from "@mui/icons-material/Grade";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

export default function MainPage() {
  return (
    <div style={{ backgroundColor: "#FCFCFC" }}>
      <div className="main_block">
        <div style={{ display: "flex" }}>
          <div className="main_text">
            <div>
              <h1
                style={{
                  fontSize: "40px",
                  fontWeight: "bolder",
                  letterSpacing: "3px",
                }}
              >
                MOGAME
              </h1>
              <div>-</div>
              <h1 style={{ letterSpacing: "5px" }}>
                Сервис создания интерактивного контента
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          // backgroundColor: "rgb(244, 244, 244)",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            width: "100%",
            padding: "40px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              gap: "50px",
            }}
          >
            <div className="column_list_item" style={{ width: "500px" }}>
              <div className="subtitle">
                <video
                  controls
                  style={{ width: "100%", maxWidth: "500px", height: "300px" }}
                >
                  <source src="/video/main.mp4" type="video/webm" />
                </video>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h2
                  style={{
                    maxWidth: "520px",
                    width: "100%",
                    margin: "20px 0",
                  }}
                >
                  Создание интерактивных сценариев для телеграма через
                  веб-сервис
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "320px",
                  }}
                >
                  <div className="subtitle">
                    <GradeIcon className="icons" />
                  </div>
                  <div style={{ listStyle: "none" }}>
                    <div className="list_item">Уникальный контент</div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "320px",
                  }}
                >
                  <div className="subtitle">
                    <MovingIcon className="icons" />
                  </div>
                  <div style={{ listStyle: "none" }}>
                    <div className="list_item">Новые подписчики</div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "320px",
                  }}
                >
                  <div className="subtitle">
                    <AttachMoneyIcon className="icons" />
                  </div>
                  <div style={{ listStyle: "none" }}>
                    <div className="list_item">Монетизация</div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "320px",
                  }}
                >
                  <div className="subtitle">
                    <SupportAgentIcon className="icons" />
                  </div>
                  <div style={{ listStyle: "none" }}>
                    <div className="list_item">Поддержка</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="block"
        style={
          {
            // backgroundColor: "rgb(244, 244, 244)"
          }
        }
      >
        <div className="title">
          <h2>Создавай свои сценарии и пусть пользователи пройдут по нему</h2>
        </div>
        <div className="column_list">
          <CustomizedTimeline />
        </div>
      </div>

      <div
        className="block"
        // style={{ backgroundColor: "#F4F4F4" }}
      >
        <div
          style={{
            display: "flex",
            padding: "20px 20px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <div>
              <img
                src="/images/workspace.png"
                alt="tg-pic"
                style={{
                  width: "100%",
                  maxWidth: "700px",
                  maxHeight: "715px",
                  height: "100%",
                  objectFit: "contain",
                  borderRadius: "5px",
                }}
              />
              <div style={{ textAlign: "center", fontSize: "14px" }}>
                Основной экран для работы со сценарием
              </div>
            </div>
            <div>
              <div
                style={{
                  textAlign: "center",
                  maxWidth: "700px",
                  width: "100%",
                }}
              >
                <div className="title">
                  <h2>Создавать это просто</h2>
                </div>
              </div>
              <div style={{ maxWidth: "700px", textAlign: "center" }}>
                Простой и интуитивно понятный интерфейс для работы над вашим
                сценарием
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <ul style={{ marginLeft: "20px" }}>
                  <li style={{ margin: "10px 0" }}>Создавай сцену</li>
                  <li style={{ margin: "10px 0" }}>Загружай видео-контент</li>
                  <li style={{ margin: "10px 0" }}>Добавляй действия</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="block"
        // style={{ backgroundColor: "#F4F4F4" }}
      >
        <div
          style={{
            display: "flex",
            padding: "20px 20px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <div>
              <div
                style={{
                  textAlign: "center",
                  maxWidth: "700px",
                  width: "100%",
                }}
              >
                <div className="title">
                  <h2>Простые настройки</h2>
                </div>
              </div>
              <div style={{ maxWidth: "700px", textAlign: "center" }}>
                Минимум настроек. Только то, что важно для быстрого запуска
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <ul>
                  <li style={{ margin: "10px 0" }}>Придумай название</li>
                  <li style={{ margin: "10px 0" }}>Создай описание</li>
                  <li style={{ margin: "10px 0" }}>Загрузи постер</li>
                  <li style={{ margin: "10px 0" }}>Создай ключи доступа</li>
                </ul>
              </div>
            </div>
            <div>
              <img
                src="/images/project_settings.png"
                alt="tg-pic"
                style={{
                  width: "100%",
                  maxWidth: "700px",
                  maxHeight: "715px",
                  height: "100%",
                  objectFit: "contain",
                  borderRadius: "5px",
                }}
              />
              <div style={{ textAlign: "center", fontSize: "14px" }}>
                Экран настроек сценария
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="block"
        // style={{ backgroundColor: "#F4F4F4" }}
      >
        <div
          style={{
            padding: "20px 20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px 0",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <h2>И всё готово!</h2>
              <div style={{ padding: "10px 0" }}>
                Предоставляй доступ и пусть пользователи начнут своё приключение
              </div>
              <Link to={"/registration"}>
                <Button
                  // sx={{ bgcolor: "white" }}
                  variant="contained"
                  size="large"
                >
                  Регистрация
                </Button>
              </Link>
            </div>
          </div>

          {/* <div
            style={{
              display: "flex",
              gap: "35px",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "space-between",
              maxWidth: "1440px",
              width: "100%",
            }}
          >
            <img
              src="/images/tg_0.png"
              alt="tg-pic"
              style={{
                width: "100%",
                maxWidth: "320px",
                maxHeight: "715px",
                height: "100%",
                objectFit: "contain",
                borderRadius: "5px",
              }}
            />
            <img
              src="/images/tg_1.png"
              alt="tg-pic"
              style={{
                width: "100%",
                maxWidth: "320px",
                maxHeight: "715px",
                height: "100%",
                objectFit: "contain",
                borderRadius: "5px",
              }}
            />
            <img
              src="/images/tg_2.png"
              alt="tg-pic"
              style={{
                width: "100%",
                maxWidth: "320px",
                maxHeight: "715px",
                height: "100%",
                objectFit: "contain",
                borderRadius: "5px",
              }}
            />
            <img
              src="/images/tg_3.png"
              alt="tg-pic"
              style={{
                width: "100%",
                maxWidth: "320px",
                maxHeight: "715px",
                height: "100%",
                objectFit: "contain",
                borderRadius: "5px",
              }}
            />
          </div> */}
        </div>
      </div>

      <div className="block">
        <div>
          <div className="title">
            <h2>FAQ</h2>
          </div>
          <AccordionComponent />
        </div>
      </div>
      <div className="footer">
        <div>
          <a href="/oferta" target="_blank" style={{ color: "white" }}>
            Оферта
          </a>
        </div>
      </div>
    </div>
  );
}
